import { Button, FormControl, Grid } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import GKModal from "components/GKModal";
import GKTextField from "components/GKTextField";
import { Controller, useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";

const WalletTopupModal = (props) => {
  const { id } = useParams();
  const { open, setOpen, refetch, walletHistoryRefetch } = props;

  const { handleSubmit, control } = useForm({
    defaultValues: {
      amount: "",
    },
  });

  const { mutate } = useMutation({
    mutationKey: ["UPDATE_WALLET_BALANCE"],
    mutationFn: async (data) => {
      try {
        const response = await axiosInstance.patch(
          `/super_admin/${id}/wallet_balance/`,
          data
        );
        return response.data;
      } catch (error) {
        console.error("API Error:", error);
        throw error;
      }
    },
    onSuccess: () => {
      refetch();
      walletHistoryRefetch();
      setOpen(false);
    },
    onError: (error) => {
      console.error("Mutation Error:", error);
    },
  });

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle={"Wallet Topup"}
      footer={
        <Grid container justifyContent={"flex-end"} gap={1}>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="outlined"
            onClick={() => setOpen(false)}
          >
            Close
          </Button>
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            type="submit"
            form="wallet-topup-form"
            variant="outlined"
          >
            Update
          </Button>
        </Grid>
      }
    >
      <form
        onSubmit={handleSubmit((values) => mutate(values))}
        id="wallet-topup-form"
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Controller
              control={control}
              name="amount"
              rules={{
                required: {
                  value: true,
                  message: "Please enter amount",
                },
              }}
              render={({ field, fieldState: { error } }) => (
                <FormControl variant="standard" fullWidth>
                  <GKTextField
                    {...field}
                    type="number"
                    inputLabel="Amount"
                    onChange={(e) => field.onChange(e.target.valueAsNumber)}
                    error={!!error}
                    helperText={error?.message}
                  />
                </FormControl>
              )}
            />
          </Grid>
        </Grid>
      </form>
    </GKModal>
  );
};

export default WalletTopupModal;
